module.exports = __webpack_public_path__ + "static/media/electrician.7ff3c67c.png";